import { Component, OnInit, QueryList, ViewChildren, inject, input, output } from "@angular/core";
import { IInteraction, NotificationService } from "../../../../core-ui";
import { QRService } from "../../../services";
import { TranslateService } from "@ngx-translate/core";
import { IShareLinkAction } from "../share-link.component";
import {
  IMenuItemContainer,
  MENU_ITEM_CONTAINER_TOKEN,
  MenuItemComponent,
} from "../../../../modules/shared/components";

@Component({
  selector: "app-share-link-qr",
  templateUrl: "./qr.component.html",
  styleUrls: ["./qr.component.scss"],
  providers: [
    {
      provide: MENU_ITEM_CONTAINER_TOKEN,
      useExisting: ShareLinkQrComponent,
    },
  ],
  standalone: false,
})
export class ShareLinkQrComponent
  implements OnInit, IShareLinkAction, IMenuItemContainer
{
  private translate = inject(TranslateService);
  private notification = inject(NotificationService);
  private qrService = inject(QRService);

  readonly interaction = input<IInteraction>(undefined);
  readonly link = input<string>(undefined);

  readonly completed = output<void>();
  readonly openChange = output<boolean>();

  @ViewChildren(MenuItemComponent) menuItems: QueryList<MenuItemComponent>;

  ngOnInit(): void {}

  getMenuItems(): MenuItemComponent[] {
    return this.menuItems.toArray();
  }

  shareLink() {
    if (!this.thereIsACustomerWhichSupportsQRCodeLink) {
      return;
    }
    this.qrService.sendQRLinkEvent(this.link());
    this.notification.show("auvious", {
      body: this.translate.instant(
        "The customer link has been sent as a QR code."
      ),
    });
    // this.shareOpen = false;
    this.openChange.emit(false);

    // this.renewCustomerLink();
    this.completed.emit();
  }

  get thereIsACustomerWhichSupportsQRCodeLink(): boolean {
    return this.qrService.isThereACustomerWhichSupportsQRCodeLink();
  }
}
